if (!customElements.get("reviews-controller")) {
  class ReviewsController extends HTMLElement {
    connectedCallback() {
      this.filterButtons = Array.from(
        this.querySelectorAll("[data-reviews-filter]")
      );
      this.reviewItems = Array.from(this.querySelectorAll("[data-tags]"));
      const desktopCount = parseInt(this.getAttribute("data-initial-count") || "2", 10);
      const mobileCount = parseInt(this.getAttribute("data-initial-count-mobile") || desktopCount, 10);
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      this.initialCount = isDesktop ? desktopCount : mobileCount;
      this.desktopGrid = this.querySelector("[data-desktop-grid]");

      // Normalize responsive hidden classes for JS show-more tracking
      if (this.desktopGrid) {
        this.desktopGrid.querySelectorAll(".review-card").forEach((card) => {
          if (isDesktop) {
            if (card.classList.contains("lg:hidden")) {
              card.classList.remove("lg:hidden");
              card.classList.add("hidden");
            }
          } else {
            card.classList.remove("lg:hidden");
          }
        });
      }

      // Select "All" pill by default
      const allButton = this.filterButtons.find(
        (btn) => btn.getAttribute("data-reviews-filter") === "all"
      );
      if (allButton) {
        allButton.classList.add("reviews-tag-selected");
      } else if (this.filterButtons.length) {
        this.filterButtons[0].classList.add("reviews-tag-selected");
      }

      this.filterReviews();
      this.initShowMore();

      this.filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          if (!button.classList.contains("reviews-tag-selected")) {
            this.filterButtons.forEach((btn) =>
              btn.classList.remove("reviews-tag-selected")
            );
            button.classList.add("reviews-tag-selected");
            this.filterReviews();
          }
        });
      });
    }

    getSelectedReviewsFilter() {
      return (
        this.filterButtons
          .find((button) => button.classList.contains("reviews-tag-selected"))
          ?.getAttribute("data-reviews-filter") || null
      );
    }

    filterReviews() {
      const selectedFilter = this.getSelectedReviewsFilter();

      this.reviewItems.forEach((item) => {
        const itemTags = item.getAttribute("data-tags").split(",");
        const shouldShow =
          !selectedFilter ||
          selectedFilter === "all" ||
          itemTags.includes(selectedFilter);

        item.style.display = shouldShow ? "" : "none";
      });

      this.resetShowMore();
      this.updateReviewCount();
    }

    initShowMore() {
      this.showMoreBtn = this.querySelector("[data-show-more-btn]");
      if (this.showMoreBtn) {
        this.showMoreBtn.addEventListener("click", () => this.showMore());
      }
    }

    resetShowMore() {
      if (!this.desktopGrid) return;

      const cards = Array.from(
        this.desktopGrid.querySelectorAll(".review-card")
      );
      let visibleIdx = 0;

      cards.forEach((card) => {
        if (card.style.display === "none") return;
        if (visibleIdx >= this.initialCount) {
          card.classList.add("hidden");
        } else {
          card.classList.remove("hidden");
        }
        visibleIdx++;
      });

      this.updateShowMoreButton();
    }

    showMore() {
      if (!this.desktopGrid) return;

      const hiddenCards = Array.from(
        this.desktopGrid.querySelectorAll(".review-card.hidden")
      ).filter((card) => card.style.display !== "none");

      hiddenCards.forEach((card) => card.classList.remove("hidden"));
      this.updateShowMoreButton();
    }

    updateShowMoreButton() {
      const wrapper = this.querySelector("[data-show-more-wrapper]");
      if (!wrapper || !this.desktopGrid) return;

      const visibleCards = Array.from(
        this.desktopGrid.querySelectorAll(".review-card")
      ).filter((card) => card.style.display !== "none");

      const shownCards = visibleCards.filter(
        (card) => !card.classList.contains("hidden")
      );
      const hiddenCards = visibleCards.filter((card) =>
        card.classList.contains("hidden")
      );

      const remainingEl = wrapper.querySelector("[data-remaining-count]");
      const visibleCountEl = wrapper.querySelector("[data-visible-count]");
      const totalCountEl = wrapper.querySelector("[data-total-count]");

      if (remainingEl) remainingEl.textContent = hiddenCards.length;
      if (visibleCountEl) visibleCountEl.textContent = shownCards.length;
      if (totalCountEl) totalCountEl.textContent = visibleCards.length;

      wrapper.style.display = hiddenCards.length === 0 ? "none" : "";
    }

    updateReviewCount() {
      const countEl = this.querySelector("[data-reviews-count]");
      if (!countEl || !this.desktopGrid) return;

      const visibleCards = Array.from(
        this.desktopGrid.querySelectorAll(".review-card")
      ).filter((card) => card.style.display !== "none");

      countEl.textContent =
        visibleCards.length +
        " review" +
        (visibleCards.length !== 1 ? "s" : "");
    }
  }

  customElements.define("reviews-controller", ReviewsController);
}
